import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RouterModule, Routes } from '@angular/router';

import { SharedModule } from 'src/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { StrackerPage } from './stracker';
import { PermissionPage } from './tutorial-permission/permission';
import { HttpClientModule } from '@angular/common/http';

const routes: Routes = [
  {
    path: '',loadComponent: () =>
      import('./stracker').then(m => m.StrackerPage)
  },
  {
    path: 'tutorial-permission', loadComponent: () =>
      import('./tutorial-permission/permission').then(m => m.PermissionPage)
  },
];

@NgModule({
  declarations: [
    StrackerPage,
    PermissionPage
  ],
  imports: [
    IonicModule,
    HttpClientModule,
    SharedModule,
    CommonModule,
    TranslateModule,
    RouterModule,
    RouterModule.forChild(routes)
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ],
  exports:[
    StrackerPage,
    PermissionPage
  ]
})
export class StrackerTrackModule {}
